import React from 'react';
import { ThemeProvider, createUseStyles } from 'react-jss'
import Services from './Services';
// import Testimonials from './Testimonials';
import Partnerships from './Partnerships';
import Schedule from './Schedule';
// import PageHeader from '../Shared/PageHeader';
import WhoAreWeSection from '../AboutPage/WhoAreWe';
import MissionSection from '../AboutPage/OurMission';
import { Helmet } from 'react-helmet-async';
import HomepageHeader from './Header';

const theme = {

}

const carouselImages = [
  { src: "/images/inhop2.webp", alt: "inhop" },
  { src: "/images/inhop1.webp", alt: "inhop" },
  { src: "/images/inhop.webp", alt: "inhop" },
];


function HomePage() {
  const styles = useStyles({ theme })

  // Enhanced structured data for homepage
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Integrated Holistic Psychotherapy",
    "alternateName": "INHOP",
    "description": "Professional counseling and psychotherapy services providing confidential support for individuals, couples, families, and organizations in Ruiru, Nairobi.",
    "url": "https://inhop.or.ke",
    "logo": "https://inhop.or.ke/logo.webp",
    "image": "https://inhop.or.ke/logo.webp",
    "@id": "https://inhop.or.ke",
    "telephone": "+254729569381",
    "email": "ihpsy18@gmail.com",
    "priceRange": "$$",
    "currenciesAccepted": "KES",
    "paymentAccepted": ["Cash", "Mobile Money", "Bank Transfer"],
    "founder": {
      "@type": "Person",
      "name": "Dr. Ann Catherine Njeri Rukwaro"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Doctors Plaza, Ground Floor, Room F06",
      "addressLocality": "Ruiru",
      "addressRegion": "Nairobi",
      "addressCountry": "KE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-1.146683",
      "longitude": "36.95794"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "00:00",
        "closes": "00:00"
      }
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+254729569381",
      "contactType": "Customer Service",
      "areaServed": "KE",
      "availableLanguage": ["English", "Swahili"],
      "hoursAvailable": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "08:00",
        "closes": "18:00"
      }
    },
    "medicalSpecialty": [
      "Psychotherapy",
      "Counseling Psychology",
      "Mental Health Counseling",
      "Clinical Psychology"
    ],
    "serviceType": [
      "Individual Therapy",
      "Couples Counseling",
      "Family Therapy",
      "Group Therapy",
      "Addiction Counseling",
      "Trauma Counseling",
      "Anxiety Treatment",
      "Depression Treatment",
      "Stress Management",
      "Grief Counseling"
    ],
    "areaServed": [
      {
        "@type": "Place",
        "name": "Ruiru, Kenya"
      },
      {
        "@type": "Place",
        "name": "Nairobi, Kenya"
      },
      {
        "@type": "Place",
        "name": "Kiambu County, Kenya"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/inhop20/",
      "https://www.instagram.com/inhop20/",
      "https://x.com/inhop20"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Counseling and Psychotherapy Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Individual Therapy",
            "description": "One-on-one counseling sessions for personal mental health support"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Family Therapy",
            "description": "Counseling services for families to improve communication and relationships"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Couples Counseling",
            "description": "Relationship counseling for couples facing challenges"
          }
        }
      ]
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <>
        {/* Enhanced Metadata */}
        <Helmet>
          <title>Integrated Holistic Psychotherapy | Nairobi</title>
          <meta
            name="description"
            content="Psychotherapy practice in Ruiru, Nairobi offering professional counseling for individuals, couples, families & organizations. Expert mental health support."
          />
          <meta
            name="keywords"
            content="counseling center Ruiru, psychologist Ruiru, psychiatrist Ruiru, psychotherapy Ruiru, counseling Nairobi, therapy Nairobi, couples counseling, marriage counseling, family therapy Kenya, addiction counseling, adolescent counseling, youth counseling, mental health Kenya, Dr Ann Catherine Njeri Rukwaro, Integrated Holistic Psychotherapy, Inhop counseling"
          />
          <link rel="canonical" href="https://inhop.or.ke/" />

          {/* Additional SEO meta tags */}
          <meta name="author" content="Dr. Ann Catherine Njeri Rukwaro, Integrated Holistic Psychotherapy" />
          <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
          <meta name="googlebot" content="index, follow" />
          <meta name="geo.region" content="KE-30" />
          <meta name="geo.placename" content="Ruiru, Nairobi, Kenya" />
          <meta name="geo.position" content="-1.146683;36.95794" />
          <meta name="ICBM" content="-1.146683, 36.95794" />
          <meta name="language" content="en-KE" />
          <meta name="revisit-after" content="7 days" />

          {/* Open Graph */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://inhop.or.ke/" />
          <meta property="og:title" content="Integrated Holistic Psychotherapy | Professional Counseling in Ruiru, Nairobi" />
          <meta
            property="og:description"
            content="Leading psychotherapy practice in Ruiru, Nairobi offering professional counseling for individuals, couples, families & organizations. Expert mental health support."
          />
          <meta property="og:image" content="https://inhop.or.ke/logo.webp" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content="Integrated Holistic Psychotherapy Logo" />
          <meta property="og:site_name" content="Integrated Holistic Psychotherapy" />
          <meta property="og:locale" content="en_KE" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@inhop20" />
          <meta name="twitter:creator" content="@inhop20" />
          <meta name="twitter:url" content="https://inhop.or.ke/" />
          <meta name="twitter:title" content="Integrated Holistic Psychotherapy | Professional Counseling in Ruiru, Nairobi" />
          <meta
            name="twitter:description"
            content="Leading psychotherapy practice in Ruiru, Nairobi offering professional counseling for individuals, couples, families & organizations."
          />
          <meta name="twitter:image" content="https://inhop.or.ke/logo.webp" />
          <meta name="twitter:image:alt" content="Integrated Holistic Psychotherapy Logo" />

          {/* Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>

          {/* Additional structured data for Organization */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Integrated Holistic Psychotherapy",
              "url": "https://inhop.or.ke",
              "logo": "https://inhop.or.ke/logo.webp",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+254729569381",
                "contactType": "customer service",
                "availableLanguage": "English"
              },
              "sameAs": [
                "https://www.facebook.com/inhop20/",
                "https://www.instagram.com/inhop20/",
                "https://x.com/inhop20"
              ]
            })}
          </script>

          {/* Website structured data */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Integrated Holistic Psychotherapy",
              "url": "https://inhop.or.ke"
            })}
          </script>

        </Helmet>

        <div className="App">
          <div className={styles.landingContainer}>
            <HomepageHeader pageTitle="Integrated Holistic Psychotherapy" main images={carouselImages} />
          </div>
          <div>
            <WhoAreWeSection />
          </div>
          <div>
            <MissionSection />
          </div>
          <div>
            <Services />
          </div>
          {/* <div className={styles.testimonialsContainer}>
            <Testimonials />
          </div> */}
          <div>
            <Partnerships />
          </div>
          <div className={styles.scheduleContainer}>
            <Schedule />
          </div>
        </div>
      </>
    </ThemeProvider>
  );
}

const useStyles = createUseStyles({
  pageContainer: {
    position: "relative",
    minHeight: "100vh",
    minWidth: "100vw",
    height: "100%",
    width: "100%",
    fontFamily: "Open Sans, sans-serif",
    display: "flex",
    flexDirection: " column"
  },
  landingContainer: {
    minHeight: "75vh",
  },
  testimonialsContainer: {
    background: "#122B3E",
  },
  scheduleContainer: {
    minHeight: "40vh",
  }
})

export default HomePage;
